import CryptoJS from "crypto-js";
import ReactGA4 from "react-ga4";
import timerStore from "stores/TimerStore";

import BaeminIcon from "static-file/images/logo/baemin.png";
import BaeminPickupIcon from "static-file/images/logo/baeminPickup.png";
import BaeminShopIcon from "static-file/images/logo/baeminShop.png";
import BaeminOneIcon from "static-file/images/logo/baeminone.png";
import BaeminStoreIcon from "static-file/images/logo/baeminStore.png";
import YogiyoIcon from "static-file/images/logo/yogiyo.png";
import CoupangIcon from "static-file/images/logo/cpe.png";
import NiceorderIcon from "static-file/images/logo/niceorder.png";
import MaverIcon from "static-file/images/logo/naver.png";
import BlankIcon from "static-file/images/logo/blank.png";
import OkPosIcon from "static-file/images/logo/okpos.png";
import OltteaAhIcon from "static-file/images/logo/oltteaah.png";
import WmpoIcon from "static-file/images/logo/wmpo.png";
import SpecialDeliveryIcon from "static-file/images/logo/specialdelivery.png";
import YogiyoExpressIcon from "static-file/images/logo/yogiyoexpress.png";
import DdangyoIcon from "static-file/images/logo/ddangyo.png";
import MukkebiIcon from "static-file/images/logo/mukkebi.png";
import DaeguroIcon from "static-file/images/logo/Daeguro.png";
import IncheonUmmIcon from "static-file/images/logo/Incheon-umm.png";
import YangsanIcon from "static-file/images/logo/Yangsan.png";
import CidIcon from "static-file/images/logo/thumbs_cid.png";
import PandaIcon from "static-file/images/logo/hungrypanda.png";
import PandaSelfIcon from "static-file/images/logo/hungrypandaself.png";
import BmSmileIcon from "static-file/images/logo/bmSmile.png";
import KioskIcon from "static-file/images/logo/kiosk.png";
import PosOrderIcon from "static-file/images/logo/posOrder.png";
import TableIcon from "static-file/images/logo/tableOrder.png";
import QRIcon from "static-file/images/logo/qrOrder.png";
import GamSungCoffeeIcon from "static-file/images/logo/gamSungCoffee.png";
import RoutineCoffeeIcon from "static-file/images/logo/routineCoffee.png";
import NpayConnectIcon from "static-file/images/logo/nPayConnect.png";
import DdangbaedalIcon from "static-file/images/logo/ddangbaedal.png";
import BaegeokCoffeeIcon from "static-file/images/logo/baekokCoffee.png";
import { MobileOrderFg } from "types";

// 콤마 추가.
export function comma(won) {
  if (!won) won = "0";
  return won.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// 콤마 추가.
export function commaString(won) {
  let val = "";
  if (!won) val = "";
  if (typeof won == "number") val = won.toString();
  return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

//콤마 제거number
export function replaceStringNum(won) {
  if (won == "0") {
    return 0;
  } else {
    return parseInt(won.replace(/,/g, ""));
  }
}

// 전체 마스킹 처리
export function stringMasking(str) {
  return str.replace(/./g, "*");
}

// 주소 특별시
export function addrFullSbs(str) {
  return str
    .replace(/^\s+/, "")
    .replace(
      /서울특별시\s|서울\s|부산광역시\s|부산\s|대구광역시\s|대구\s|인천광역시\s|인천\s|광주광역시\s|광주\s|대전광역시\s|대전\s|울산광역시\s|울산\s|세종특별자치시\s|세종\s|경기도\s|경기\s|강원도\s|강원\s|강원특별자치도\s|충청북도\s|충북\s|충청남도\s|충남\s|전라북도\s|전북\s|전북특별자치도\s|전라남도\s|전남\s|경상북도\s|경북\s|포항시\s|포항\s|경상남도\s|경남\s|진주시\s|진주\s|제주특별자치도\s|제주\s/g,
      ""
    );
}

/**
 * 그래프 Y축의 최대값을 올림하여 계산
 * 예: 43,210 -> 50,000 / 8,100 -> 10,000 / 750 -> 1,000
 * @param {number} maxValue 실제 데이터의 최댓값 (원 단위)
 * @returns {number} 그래프 Y축 최댓값으로 사용할 숫자 (원 단위)
 */
export function getMaxValueY(maxValue) {
  if (maxValue <= 0) return 10000; // 매출이 없을 때 기본값

  const exponent = Math.floor(Math.log10(maxValue));
  const powerOf10 = 10 ** exponent;
  const normalizedValue = maxValue / powerOf10; // 1 ~ 10 사이의 값으로 정규화

  let niceCeiling;
  if (normalizedValue > 5) {
    niceCeiling = 10;
  } else if (normalizedValue > 2) {
    niceCeiling = 5;
  } else if (normalizedValue > 1) {
    niceCeiling = 2;
  } else {
    niceCeiling = 1;
  }

  return niceCeiling * powerOf10;
}

/**
 * 숫자를 받아 10,000 미만이면 '원', 이상이면 '만' 단위를 붙여 반환합니다.
 * @param {number} price 원 단위의 금액
 * @returns {string} 단위가 포함된 문자열 (예: "5,000원", "12.5만")
 */
export function formatPriceUnit(price) {
  const roundedPrice = Math.round(price); // 정수로 만들어 부동소수점 문제 방지

  if (roundedPrice < 10000) {
    return `${roundedPrice.toLocaleString()}원`;
  }

  const priceInMan = roundedPrice / 10000;
  return `${Number(priceInMan.toFixed(1))}만`;
}

//막대그래프 height 계산
export function graphHeight(rootStore, yAxisMax, won) {
  const GRAPH_PIXEL_HEIGHT = 244;

  const salesAmount = replaceStringNum(won);

  if (salesAmount === 0 || yAxisMax === 0) {
    return 0;
  }

  // (현재 매출 / Y축 최댓값) * 그래프 전체 높이
  return (salesAmount / yAxisMax) * GRAPH_PIXEL_HEIGHT;
}

export function salesMaxY(rootStore, num) {
  let salesMax = num;
  let salesLen = String(num).length - 6;
  let salesMaxVal = 0;

  if (salesMax < 0) {
    salesMaxVal = 100000;
    return salesMaxVal;
  } else {
    let calArray = [
      100000 * 10 ** salesLen,
      250000 * 10 ** salesLen,
      500000 * 10 ** salesLen,
      750000 * 10 ** salesLen,
      100000 * 10 ** (salesLen + 1),
    ];
    let minArray = [];

    calArray.map((n, index) => (n >= salesMax ? minArray.push(n) : ""));

    let min = minArray.reduce((a, b) => Math.min(a, b));
    salesMaxVal = min / 10000;
    return salesMaxVal;
  }
}

// 문자열 바이트 체크 ( value: 체크할 문자열, maxByte: 제한 byte )
export function checkByte(value, maxByte) {
  const text_len = value.length;

  let totalByte = 0;
  for (let i = 0; i < text_len; i++) {
    const each_char = value.charAt(i);
    const uni_char = escape(each_char); //유니코드 형식으로 변환
    if (uni_char.length > 4) {
      // 한글 : 2Byte
      totalByte += 2;
    } else {
      // 영문,숫자,특수문자 : 1Byte
      totalByte += 1;
    }
  }
  if (totalByte > maxByte) {
    return false;
  } else {
    return true;
  }
}

//입력값 숫자만 허용
export function onlyNumber(value) {
  return value.replace(/[^0-9]/g, "");
}

//복호화
export function aesDecoding(data) {
  const aes128SecretKey = "0123456789abcdef"; // key 값 16 바이트
  const aes128Iv = "0123456789abcdef"; //iv 16 바이트
  const cipher = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(aes128SecretKey), {
    iv: CryptoJS.enc.Utf8.parse(aes128Iv), // [Enter IV (Optional) 지정 방식]
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC, // [cbc 모드 선택]
  });
  const originalText = cipher.toString(CryptoJS.enc.Utf8); // output: '암호화할 값'

  return originalText;
}

//암호화
export function aesEncoding(data) {
  const aes128SecretKey = "0123456789abcdef"; // key 값 16 바이트
  const aes128Iv = "0123456789abcdef"; //iv 16 바이트
  const cipher = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(aes128SecretKey), {
    iv: CryptoJS.enc.Utf8.parse(aes128Iv), // [Enter IV (Optional) 지정 방식]
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC, // [cbc 모드 선택]
  });
  return cipher;
}

export function analytice(string) {
  ReactGA4.send({ hitType: "pageview", page: string });
}

export function analyticeEvent(category, action, label) {
  ReactGA4.event({
    category: category,
    action: action,
    label: label,
  });
}

export function partnerIcon(partnerType) {
  let img_icon = BlankIcon;
  if (partnerType === "BAEMIN" || partnerType === "baemin" || partnerType === "배달의민족") {
    img_icon = BaeminIcon;
  } else if (partnerType === "BAEMIN_PICKUP") {
    img_icon = BaeminPickupIcon;
  } else if (partnerType === "BAEMIN_SHOP") {
    img_icon = BaeminShopIcon;
  } else if (
    partnerType === "BAEMINONE" ||
    partnerType === "baemin1" ||
    partnerType === "배민1" ||
    partnerType === "BAEMIN1"
  ) {
    img_icon = BaeminOneIcon;
  } else if (
    partnerType === "BAEMIN_STORE" ||
    partnerType === "baemin_store" ||
    partnerType === "baeminstore" ||
    partnerType === "배민스토어" ||
    partnerType === "BAEMINSTORE"
  ) {
    img_icon = BaeminStoreIcon;
  } else if (partnerType === "YOGIYO" || partnerType === "yogiyo" || partnerType === "요기요") {
    img_icon = YogiyoIcon;
  } else if (
    partnerType === "YOGIYOEXPRESS" ||
    partnerType === "yogiyoexpress" ||
    partnerType === "요기요익스프레스" ||
    partnerType === "요기요 요기배달"
  ) {
    img_icon = YogiyoExpressIcon;
  } else if (partnerType === "COUPANG" || partnerType === "eats" || partnerType === "쿠팡이츠") {
    img_icon = CoupangIcon;
  } else if (partnerType === "NICE") {
    img_icon = NiceorderIcon;
  } else if (partnerType === "NAVER" || partnerType === "NAVERBOOKING" || partnerType === "naverbooking" || partnerType === "naver") {
    img_icon = MaverIcon;
  } else if (partnerType === "NAVERCONNECT" || partnerType === "naverConnect") {
    img_icon = NpayConnectIcon;
  } else if (partnerType === "CID") {
    img_icon = CidIcon;
  } else if (partnerType === "POS") {
    img_icon = PosOrderIcon;
  } else if (partnerType === "KIOSK") {
    img_icon = KioskIcon;
  } else if (partnerType === "OKDC") {
    img_icon = TableIcon;
  } else if (partnerType === "QR") {
    img_icon = QRIcon;
  } else if (partnerType === "BMSMILE" || partnerType === "bmsmile" || partnerType === "위글루션") {
    img_icon = BmSmileIcon;
  } else if (partnerType === "WMPO" || partnerType === "wmpo" || partnerType === "위메프오") {
    img_icon = WmpoIcon;
  } else if (partnerType === "SPECIALDELIVERY" || partnerType === "specialdelivery" || partnerType === "배달특급") {
    img_icon = SpecialDeliveryIcon;
  } else if (partnerType === "DDANGYO" || partnerType === "ddangyo" || partnerType === "땡겨요") {
    img_icon = DdangyoIcon;
  } else if (partnerType === "MUKKEBI" || partnerType === "mukkebi" || partnerType === "먹깨비") {
    img_icon = MukkebiIcon;
  } else if (partnerType === "DAEGURO" || partnerType === "daeguro" || partnerType === "대구로") {
    img_icon = DaeguroIcon;
  } else if (partnerType === "INCHEONEUM" || partnerType === "incheoneum" || partnerType === "인천이음") {
    img_icon = IncheonUmmIcon;
  } else if (partnerType === "BAEDALYS" || partnerType === "baedalys" || partnerType === "배달양산") {
    img_icon = YangsanIcon;
  } else if (partnerType === "PANDASELF" || partnerType === "pandaself") {
    img_icon = PandaSelfIcon;
  } else if (partnerType === "PANDA" || partnerType === "panda" || partnerType === "헝그리판다") {
    img_icon = PandaIcon;
  } else if (partnerType === "GAMSUNGCOFFEE" || partnerType === "gamsungcoffee" || partnerType === "감성커피") {
    img_icon = GamSungCoffeeIcon;
  } else if (partnerType === "OLTTEA_AH" || partnerType === "oltteaah" || partnerType === "올때아아") {
    img_icon = OltteaAhIcon;
  } else if (partnerType === "ROUTINE_COFFEE" || partnerType === "routinecoffee") {
    img_icon = RoutineCoffeeIcon;
  } else if (partnerType === "DDANGBAEDAL" || partnerType === "ddangbaedal" || partnerType === "땡배달") {
    img_icon = DdangbaedalIcon;
  } else if (partnerType === "BAEGEOK_COFFEE" || partnerType === "baegeokcoffee" || partnerType === "백억커피") {
    img_icon = BaegeokCoffeeIcon;
  } else {
    img_icon = OkPosIcon;
  }
  return img_icon;
}

export function partnerIconFg(order) {
  if (!order) {
    return BlankIcon;
  }

  let img_icon = BlankIcon;
  const { mobileOrderFg, morderTypeCd } = order;

  if (mobileOrderFg === MobileOrderFg.NAVER || mobileOrderFg === MobileOrderFg.NAVER_BOOKING) {
    img_icon = MaverIcon;
  } else if (mobileOrderFg === MobileOrderFg.YOGIYO) {
    img_icon = YogiyoIcon;
  } else if (mobileOrderFg === MobileOrderFg.BAEMIN) {
    if (morderTypeCd === "P") {
      img_icon = BaeminPickupIcon;
    } else {
      img_icon = BaeminIcon;
    }
  } else if (mobileOrderFg === MobileOrderFg.BAEMIN_ONE) {
    img_icon = BaeminOneIcon;
  } else if (mobileOrderFg === MobileOrderFg.BAEMIN_STORE) {
    img_icon = BaeminStoreIcon;
  } else if (mobileOrderFg === MobileOrderFg.YOGIYO_EXPRESS) {
    img_icon = YogiyoExpressIcon;
  } else if (mobileOrderFg === MobileOrderFg.PANDA_SELF_DELIVERY) {
    img_icon = PandaSelfIcon;
  } else if (mobileOrderFg === MobileOrderFg.HUNGRY_PANDA) {
    img_icon = PandaIcon;
  } else if (mobileOrderFg === MobileOrderFg.WMPO) {
    img_icon = WmpoIcon;
  } else if (mobileOrderFg === MobileOrderFg.DDANGBAEDAL) {
    img_icon = DdangbaedalIcon;
  } else if (mobileOrderFg === MobileOrderFg.DDANGYO) {
    img_icon = DdangyoIcon;
  } else if (mobileOrderFg === MobileOrderFg.BMSMILE) {
    img_icon = BmSmileIcon;
  } else if (mobileOrderFg === MobileOrderFg.MUKKEBI) {
    img_icon = MukkebiIcon;
  } else if (mobileOrderFg === MobileOrderFg.GAMSUNG_COFFEE) {
    img_icon = GamSungCoffeeIcon;
  } else if (mobileOrderFg === MobileOrderFg.OLTTEA_AH) {
    img_icon = OltteaAhIcon;
  } else if (mobileOrderFg === MobileOrderFg.ROUTINE_COFFEE) {
    img_icon = RoutineCoffeeIcon;
  } else if (mobileOrderFg === MobileOrderFg.BAEGEOK_COFFEE) {
    img_icon = BaegeokCoffeeIcon;
  } else if (mobileOrderFg === MobileOrderFg.NAVERCONNECT) {
    img_icon = NpayConnectIcon;
  } else {
    img_icon = OkPosIcon;
  }
  return img_icon;
}

export function partnerText(partnerType) {
  let channel_text = "";
  if (partnerType === "BAEMIN" || partnerType === "baemin") {
    channel_text = "배민";
  } else if (partnerType === "BAEMINONE" || partnerType === "baemin1" || partnerType === "BAEMIN1") {
    channel_text = "배민1";
  } else if (
    partnerType === "BAEMIN_STORE" ||
    partnerType === "baemin_store" ||
    partnerType === "baeminstore" ||
    partnerType === "BAEMINSTORE"
  ) {
    channel_text = "배민스토어";
  } else if (partnerType === "YOGIYO" || partnerType === "yogiyo") {
    channel_text = "요기요";
  } else if (partnerType === "YOGIYOEXPRESS" || partnerType === "yogiyoexpress") {
    channel_text = "요기배달";
  } else if (partnerType === "COUPANG" || partnerType === "eats") {
    channel_text = "쿠팡이츠";
  } else if (partnerType === "NICE") {
    channel_text = "나이스";
  } else if (
    partnerType === "naver" ||
    partnerType === "NAVER" ||
    partnerType === "naverBooking" ||
    partnerType === "NAVERBOOKING"
  ) {
    channel_text = "네이버";
  } else if (partnerType === "naverConnect" || partnerType === "NAVERCONNECT") {
    channel_text = "Npay 커넥트";
  } else if (partnerType === "CID") {
    channel_text = "CID";
  } else if (partnerType === "BMSMILE" || partnerType === "bmsmile") {
    channel_text = "위글루션";
  } else if (partnerType === "WMPO" || partnerType === "wmpo") {
    channel_text = "위메프오";
  } else if (partnerType === "SPECIALDELIVERY" || partnerType === "specialdelivery") {
    channel_text = "배달특급";
  } else if (partnerType === "MUKKEBI" || partnerType === "mukkebi") {
    channel_text = "먹깨비";
  } else if (partnerType === "DDANGYO" || partnerType === "ddangyo") {
    channel_text = "땡겨요";
  } else if (partnerType === "DAEGURO" || partnerType === "daeguro") {
    channel_text = "대구로";
  } else if (partnerType === "INCHEONEUM" || partnerType === "incheoneum") {
    channel_text = "인천이음";
  } else if (partnerType === "BAEDALYS" || partnerType === "baedalys") {
    channel_text = "배달양산";
  } else if (partnerType === "panda" || partnerType === "PANDA") {
    channel_text = "헝그리판다";
  } else if (partnerType === "pandaself" || partnerType === "PANDASELF") {
    channel_text = "판다배송";
  } else if (partnerType === "GAMSUNGCOFFEE" || partnerType === "gamsungcoffee") {
    channel_text = "감성커피";
  } else if (partnerType === "OLTTEA_AH" || partnerType === "oltteaah") {
    channel_text = "올때아아";
  } else if (partnerType === "THE_LITER" || partnerType === "theliter") {
    channel_text = "더리터";
  } else if (partnerType === "TALK_PICK" || partnerType === "talkpick") {
    channel_text = "톡포장";
  } else if (partnerType === "ROUTINE_COFFEE" || partnerType === "routinecoffee") {
    channel_text = "루틴커피";
  } else if (partnerType === "DEMONSTRATION" || partnerType === "demonstration") {
    channel_text = "VD시연용";
  } else if (partnerType === "DDANGBAEDAL" || partnerType === "ddangbaedal") {
    channel_text = "땡배달";
  } else if (partnerType === "BAEGEOK_COFFEE" || partnerType === "baegeokcoffee") {
    channel_text = "백억커피";
  } else if (partnerType === "etc") {
    channel_text = "기타";
  } else if (partnerType === "all") {
    channel_text = "전체";
  } else {
    channel_text = "";
  }
  return channel_text;
}

//depositCk
export function getDepositCheck(order) {
  // order 객체 null/undefined 체크
  if (!order) {
    return false;
  }

  let depositCk = false;
  //if (order.partnerType === "CID") {
  //depositCk = false;
  //결제금액과 받을 금액이 같으면 비활성화
  if (order.orderAmount == 0 && order.totDcAmount > 0 && order.orderTotAmount == order.totDcAmount) {
    depositCk = false;
  }
  if (
    order.payType == "PAID" ||
    (order.orderAmount > 0 && order.gstPayAmt > 0 && order.orderAmount === order.gstPayAmt)
  ) {
    depositCk = true;
  }

  //}
  return depositCk;
}

export function getMobileOrderNo(order) {
  // order 객체 null/undefined 체크
  if (!order) {
    return { mobileOrderNoView: "", partnerType: "" };
  }

  switch (order.mobileOrderFg) {
    case "00" /*POS선불*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "POS" };
    case "18" /*KIOSK*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "KIOSK" };
    case "23" /*CID*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "CID" };
    case "24" /*OKDC*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "OKDC" };
    case "37" /*QR*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "QR" };
    case "20" /*NAVER*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "NAVER" };
    case "27" /*요기요*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "YOGIYO" };
    case "28" /*배민*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "BAEMIN" };
    case "29" /*배민원*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "BAEMIN1" };
    case "30" /*배민스토어*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "BAEMINSTORE" };
    case "31" /*익스프레스*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "YOGIYOEXPRESS" };
    case "32" /*헝그리판다(자체배달)*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "PANDASELF" };
    case "33" /*헝그리판다*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "PANDA" };
    case "34" /*위메프오*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "WMPO" };
    case "35" /*땡겨요*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "DDANGYO" };
    case "36" /*비엠스마일*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "BMSMILE" };
    case "40" /*먹깨비*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "MUKKEBI" };
    case "43" /*감성커피*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "GAMSUNGCOFFEE" };
    case "44" /*올때아아*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "OLTTEA_AH" };
    case "45" /*톡포장*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "TALK_PICK" };
    case "47" /*더리터*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "THE_LITER" };
    case "48" /*네이버 예약*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "NAVERBOOKING" };
    case "49" /*루틴커피*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "ROUTINE_COFFEE" };
    case "50" /*VD시연용*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "DEMONSTRATION" };
    case "51" /*네이버 커넥트*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "NAVERCONNECT" };
    case "52" /*땡배달*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "DDANGBAEDAL" };
    case "53" /*백억커피*/:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "BAEGEOK_COFFEE" };
    case "08" /*ONETOSS 후킹*/:
      if (order.mobileOrderNo.substr(0, 1) === "B" && order.mobileOrderNo.length === 10) {
        /*배민*/
        return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-4), partnerType: "BAEMIN" };
      } else if (order.mobileOrderNo.substr(0, 1) === "T" && order.mobileOrderNo.length === 12) {
        /*배민ONE*/
        return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-4), partnerType: "BAEMINONE" };
      } else if (order.mobileOrderNo.substr(0, 1) === "F" && order.mobileOrderNo.length === 16) {
        /*요기요*/
        return { ...order, mobileOrderNoView: order.registNumber, partnerType: "YOGIYO" };
      } else if (order.mobileOrderNo.length === 6) {
        /*쿠팡이츠*/
        return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-6), partnerType: "COUPANG" };
      } else {
        return order;
      }
    case "22" /* okpos 후킹 */:
      if (order.partnerType == null) {
        //배달요청 토스트알림 추가하면서 임시로 넣음
        if (order.type !== "dlvReq") {
          return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-6), partnerType: "" };
        } else {
          return order;
        }
      } else {
        if (order.partnerType.toUpperCase() === "YOGIYO") {
          // if (order.registNumber == null) {
          //     order.registNumber = "ㅤ"
          //     //return { ...order, mobileOrderNoView: order.registNumber, partnerType: "YOGIYO" }
          // }
          if (order.partnerType.toUpperCase() === "YOGIYO") {
            if (order.registNumber == null) {
              order.registNumber = "ㅤ";
            }
            if (order.morderTypeCd == "P") {
              return { ...order, mobileOrderNoView: order.registNumber.slice(-5), partnerType: "YOGIYO" };
            } else {
              return { ...order, mobileOrderNoView: order.registNumber, partnerType: "YOGIYO" };
            }
          } else {
            return { ...order, mobileOrderNoView: order.registNumber.slice(-5), partnerType: "YOGIYO" };
          }
        } else if (order.partnerType.toUpperCase() === "YOGIYOEXPRESS") {
          if (order.registNumber == null) {
            order.registNumber = "ㅤ";
          }
          return {
            ...order,
            mobileOrderNoView: order.registNumber,
            partnerType: "YOGIYOEXPRESS",
          };
        } else if (order.partnerType.toUpperCase() === "BAEMIN" || order.partnerType.toUpperCase() === "BAEMINOLD") {
          return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-4), partnerType: "BAEMIN" };
        } else if (
          order.partnerType.toUpperCase() === "BAEMINONEOLD" ||
          order.partnerType.toUpperCase() === "BAEMINONE" ||
          order.partnerType.toUpperCase() === "BAEMIN1" ||
          order.partnerType.toUpperCase() === "BAEMIN1OLD"
        ) {
          return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-4), partnerType: "BAEMINONE" };
        } else if (order.partnerType.toUpperCase() === "COUPANG" || order.partnerType.toUpperCase() === "EATS") {
          return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-6), partnerType: "COUPANG" };
        } else if (order.partnerType.toUpperCase() === "DDANGBAEDAL") {
          return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-5), partnerType: "DDANGBAEDAL" };
        } else if (order.partnerType.toUpperCase() === "WMPO") {
          return { ...order, mobileOrderNoView: order.registNumber, partnerType: "WMPO" };
        } else if (order.partnerType.toUpperCase() === "SPECIALDELIVERY") {
          return { ...order, mobileOrderNoView: order.registNumber, partnerType: "SPECIALDELIVERY" };
        } else if (order.partnerType.toUpperCase() === "DDANGYO") {
          return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-5), partnerType: "DDANGYO" };
        } else if (order.partnerType.toUpperCase() === "MUKKEBI") {
          return { ...order, mobileOrderNoView: order.mobileOrderNo.substr(1, 6), partnerType: "MUKKEBI" };
        } else if (order.partnerType.toUpperCase() === "DAEGURO") {
          return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-7), partnerType: "DAEGURO" };
        } else if (order.partnerType.toUpperCase() === "INCHEONEUM") {
          return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-6), partnerType: "INCHEONEUM" };
        } else if (order.partnerType.toUpperCase() === "BAEDALYS") {
          return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-5), partnerType: "BAEDALYS" };
        } else {
          return { ...order, mobileOrderNoView: order.mobileOrderNo.slice(-6), partnerType: "" };
        }
      }
    default:
      return { ...order, mobileOrderNoView: order.orderNo, partnerType: "" };
  }
}

//orderTypeStyle
export function getOrderTypeStyle(order) {
  let orderTypeStyle;
  switch (order) {
    case "DELIVERY":
      orderTypeStyle = "sortation sortation_delivery";
      break;
    case "PICKUP":
      orderTypeStyle = "sortation sortation_takeout";
      break;
    case "TABLE":
      orderTypeStyle = "sortation sortation_table";
      break;
    case "D":
      orderTypeStyle = "sortation_delivery";
      break;
    case "P":
      orderTypeStyle = "sortation_takeout";
      break;
    case "O":
      orderTypeStyle = "sortation_table";
      break;
    default:
      orderTypeStyle = "sortation";
      break;
  }
  return orderTypeStyle;
}

//주문자정보 조합
export function getOrderInfoText(order) {
  // order 객체 null/undefined 체크
  if (!order) {
    return "주문자 정보가 없습니다";
  }

  let infoText = "";
  let tableTempText;
  let cstTelNo;
  let dlvAddrFullReplace = addrFullSbs(order.dlvAddrFull);

  tableTempText = order.tableNm == null ? "" : "테이블번호 " + order.tableNm + " / ";
  infoText = tableTempText + infoText;

  if (order.orderType === "DELIVERY") {
    if (
      (order.stepCd == "700" || order.stepCd == "900") &&
      baeminMobileOrderFg(order.mobileOrderFg) &&
      order.cstTelNo != null &&
      order.cstTelNo.trim() != ""
    ) {
      cstTelNo = order.cstTelNo.substr(0, order.cstTelNo.length - 4) + "****";
    } else {
      cstTelNo = order.cstTelNo;
    }

    if (order.registNumber != null && order.registNumber.trim() != "") {
      infoText =
        order.morderTypeCd == "P" && order.mobileOrderFg === "28"
          ? "접수번호 " + order.registNumber
          : order.registNumber;
      if (order.cstNm != null && order.cstNm.trim() != "") {
        infoText = infoText + " / " + order.cstNm;
        if (order.cstTelNo != null && order.cstTelNo.trim() != "") {
          infoText = infoText + " / " + cstTelNo;
        }
      } else {
        if (order.cstTelNo != null && order.cstTelNo.trim() != "") {
          infoText = infoText + " / " + cstTelNo;
        }
      }
    } else {
      if (order.cstNm != null && order.cstNm.trim() != "") {
        infoText = order.cstNm;
        if (order.cstTelNo != null && order.cstTelNo.trim() != "") {
          infoText = infoText + " / " + cstTelNo;
        }
      } else {
        if (order.cstTelNo != null && order.cstTelNo.trim() != "") {
          infoText = cstTelNo;
        } else {
          infoText = "주문자 정보가 없습니다";
        }
      }
    }

    if (order.dlvAddrFull != null && order.dlvAddrFull.trim() != "") {
      if (order.addr2) {
        if (baeminMobileOrderFg(order.mobileOrderFg) && (order.stepCd == "700" || order.stepCd == "900")) {
          if (order.dlvAddrDetail != "" && order.dlvAddrDetail != undefined && order.dlvAddrDetail != null) {
            infoText = addrFullSbs(order.dlvAddr) + " " + stringMasking(order.dlvAddrDetail) + " (" + order.addr2 + ")";
          } else {
            infoText = dlvAddrFullReplace + " (" + order.addr2 + ")";
          }
        } else {
          infoText = dlvAddrFullReplace + " (" + order.addr2 + ")";
        }
      } else {
        infoText = dlvAddrFullReplace;
      }
    } else {
      infoText = "주문자 정보가 없습니다";
    }

    if (order.mobileOrderFg == "29") {
      infoText = order.dlvAddr;
    }
  }
  let list = [];
  let pickTableTxt = "";
  if (order.morderTypeCd == "O" || order.morderTypeCd == "P") {
    if (order.reservedTime != null && order.reservedTime != "" && order.reservedTime != undefined) {
      infoText = order.reservedTime + " 예약";
      list.push(order.reservedTime + " 예약");
    }
    if (order.bellNo || order.deliverNo) {
      infoText = infoText + " / " + "진동벨 " + (order.bellNo || order.deliverNo);
      list.push(" 진동벨 " + (order.bellNo || order.deliverNo));
    }
    if (order.registNumber != null && order.registNumber != "" && order.registNumber != undefined) {
      infoText = infoText + " / " + order.registNumber;
      list.push(order.registNumber);
    }
    if (order.waitingNo != null && order.waitingNo != "" && order.waitingNo != undefined) {
      infoText = infoText + "대기번호 " + order.waitingNo;
      list.push("대기번호 " + order.waitingNo);
    }
    if (order.visitorNo != null && order.visitorNo != "" && order.visitorNo != undefined) {
      infoText = infoText + " / " + order.visitorNo;
      list.push(order.visitorNo + "명");
    }
    if (order.tableNo != null && order.tableNo != "" && order.tableNo != undefined) {
      infoText = infoText + " / " + "테이블 " + order.tableNo;
      list.push("테이블 " + order.tableNo);
    }
    if (order.tableNm != null && order.tableNm != "" && order.tableNm != undefined) {
      infoText = infoText + " / " + order.tableNm;
      list.push(order.tableNm);
    }
    if (order.cstNm != null && order.cstNm != "" && order.cstNm != undefined) {
      infoText = infoText + " / " + order.cstNm;
      list.push(order.cstNm);
    }
    if (
      order.partnerEtcInfo != null &&
      order.partnerEtcInfo != "" &&
      order.partnerEtcInfo != undefined &&
      order.partnerEtcInfo == "no_show"
    ) {
      infoText = infoText + " / " + "고객미방문";
      list.push("고객미방문");
    }
    if (order.cstTelNo != null && order.cstTelNo != "" && order.cstTelNo != undefined) {
      infoText = infoText + " / " + order.cstTelNo;
      list.push(order.cstTelNo);
    }

    if (list.length > 0) {
      for (let i = 0; i < list.length; i++) {
        if (i + 1 == list.length) {
          pickTableTxt += list[i];
        } else {
          pickTableTxt += list[i] + " / ";
        }
      }
      infoText = pickTableTxt;
    } else {
      infoText = "주문자 정보가 없습니다";
    }
  } else {
    //배달
    if (order.reservedTime != null && order.reservedTime != "" && order.reservedTime != undefined) {
      infoText = order.reservedTime + " 예약 주문 / " + infoText;
    }
  }

  return infoText;
}

//채널주문번호 로직
export function getChannelMobileOrderNo(order) {
  // order 객체 null/undefined 체크
  if (!order) {
    return "";
  }

  let orderNo = "";
  if (order.partnerType === "BAEMIN" || order.partnerType === "baemin") {
    orderNo = order.mobileOrderNo.slice(-4);
  } else if (order.partnerType === "BAEMINONE" || order.partnerType === "BAEMIN1") {
    orderNo = order.mobileOrderNo.slice(-4);
  } else if (order.partnerType === "BAEMINSTORE" || order.partnerType === "baeminstore") {
    orderNo = order.mobileOrderNo.slice(-4);
  } else if (order.partnerType === "YOGIYO" || order.partnerType === "yogiyo") {
    orderNo = order.mobileOrderNo.slice(-5);
  } else if (order.partnerType === "YOGIYOEXPRESS" || order.partnerType === "yogiyoexpress") {
    orderNo = order.mobileOrderNo.slice(-5);
  } else if (order.partnerType === "COUPANG" || order.partnerType === "eats") {
    orderNo = order.mobileOrderNo.slice(-6);
  } else if ((order.partnerType === "WMPO" || order.partnerType === "wmpo") && order.mobileOrderFg != "34") {
    orderNo = order.registNumber;
  } else if ((order.partnerType === "WMPO" || order.partnerType === "wmpo") && order.mobileOrderFg == "34") {
    orderNo = order.mobileOrderNo.slice(-6);
  } else if (order.partnerType === "SPECIALDELIVERY" || order.partnerType === "specialdelivery") {
    orderNo = order.registNumber;
  } else if (order.partnerType === "DDANGYO" || order.partnerType === "ddangyo") {
    orderNo = order.mobileOrderNo.slice(-5);
  } else if (order.partnerType === "DDANGBAEDAL" || order.partnerType === "ddangbaedal") {
    orderNo = order.mobileOrderNo.slice(-5);
  }else if (order.partnerType === "MUKKEBI" || order.partnerType === "mukkebi") {
    orderNo = order.mobileOrderNo.substr(1, 6);
  } else if (order.partnerType === "PANDA" || order.partnerType === "PANDASELF") {
    orderNo = order.mobileOrderNo.slice(-6);
  } else {
    orderNo = order.mobileOrderNo.slice(-6);
  }
  return orderNo;
}

export function typeTxt(type, idx) {
  let option = [];
  let txt = "";
  if (type == "menu") {
    txt = "메뉴";
  } else {
    txt = "옵션";
  }
  if (idx == 1) {
    option.push("," + txt);
  } else {
    option.push(txt);
  }

  if (idx == 1) {
    return option;
  } else {
    return txt;
  }
}

export function apiMobileOrderFg(mobileOrderFg) {
  if (
    mobileOrderFg == "20" ||
    mobileOrderFg == "25" ||
    mobileOrderFg == "26" ||
    mobileOrderFg == "27" ||
    mobileOrderFg == "31" ||
    mobileOrderFg == "32" ||
    mobileOrderFg == "33" ||
    mobileOrderFg == "34" ||
    mobileOrderFg == "35" ||
    mobileOrderFg == "36"
  ) {
    return true;
  }
}

export function jinjuNubigoMobileOrderFg(mobileOrderFg) {
  if (mobileOrderFg == "25" || mobileOrderFg == "26") {
    return true;
  }
}

export function ygyMobileOrderFg(mobileOrderFg) {
  if (mobileOrderFg == "27" || mobileOrderFg == "31") {
    return true;
  }
}

export function baeminMobileOrderFg(mobileOrderFg) {
  if (mobileOrderFg == "28" || mobileOrderFg == "29" || mobileOrderFg == "30") {
    return true;
  }
}

export function baerminUseYn(rootStore) {
  if (rootStore.settingStore.getBaeminUseStatus.isCurrentPosBaeminUse == "Y") {
    return true;
  } else {
    return false;
  }
}

export function baeminUsePosNo(rootStore) {
  if (rootStore.searchStore.getSession.connPosNo == rootStore.settingStore.getBaeminUseStatus.baeminUsePosNo) {
    return true;
  } else {
    return false;
  }
}

//헝그리판다 mobileOrderFg
export function hungryPandaMobileOrderFg(mobileOrderFg) {
  if (mobileOrderFg === "32" || mobileOrderFg === "33") {
    return true;
  }
}

//자체배달 mobileOrderFg
export function selfDlvMobileOrderFg(mobileOrderFg) {
  //배민원,헝그리판다자체배달,요기배달,땡배달
  if (mobileOrderFg === "29" || mobileOrderFg === "32" || mobileOrderFg === "31" || mobileOrderFg === "52") {
    return true;
  }
}

// 배달업체명
export function dlvPtnerNm(order) {
  // order 객체 null/undefined 체크
  if (!order) {
    return "배달업체 정보가 없습니다.";
  }

  if (order.mobileOrderFg == "29" || order.mobileOrderFg == "30") {
    return "배민라이더";
  } else if (order.mobileOrderFg == "31") {
    return "요기요 라이더";
  } else if (order.mobileOrderFg == "28" && order.dlvPtnerNm == null) {
    return "배달의민족 주문채널";
  } else if (order.mobileOrderFg == "32" && order.dlvPtnerNm == null) {
    return "헝그리판다 라이더";
  } else if (!order.dlvPtnerNm) {
    return "배달업체 정보가 없습니다.";
  } else {
    return order.dlvPtnerNm;
  }
}

export function expectTime(time) {
  const startTime = new Date(time);
  const timeDiff = startTime - timerStore.currentTime;
  let statusNumber = Math.floor(timeDiff / (60 * 1000));
  return statusNumber;
}

// POS | KIOSK | QR | TABLE_ORDER 시 true 반환
export function posOrdermMbileOrderFg(mobileOrderFg) {
  if (
    mobileOrderFg === MobileOrderFg.POS_PREPAID ||
    mobileOrderFg === MobileOrderFg.KIOSK ||
    mobileOrderFg === MobileOrderFg.TABLE_ORDER ||
    mobileOrderFg === MobileOrderFg.QR_ORDER
  ) {
    return true;
  }
  return false;
}

//홀/테이블주문 보기탭 활성화 여부
export function posOrderTab(rootStore) {
  let check = false;
  if (rootStore.settingStore.getKioskOrderState == "posOrder") {
    check = true;
  }
  return check;
}

// //진동벨, 알림톡 판단
export function posOrderCallType(rootStore, order) {
  // order 객체 null/undefined 체크
  if (!order) {
    return "";
  }

  const { bellNo, deliverNo, mobileOrderFg } = order;

  // 진동벨 있을 때
  if (bellNo || deliverNo) {
    const usePagerBell = rootStore.settingStore.getPagerBellYn === "Y";
    return usePagerBell ? "PagerBell" : "";
  }

  // --- 여기서부터는 진동벨이 없는 경우 ---
  let alarmTalk = false;
  switch (mobileOrderFg) {
    case MobileOrderFg.POS_PREPAID: // POS 알림톡 사용
      alarmTalk = rootStore.settingStore.getPosAlarmtalkYn === "1"; // 0: 미사용, 1: 사용
      break;
    case MobileOrderFg.KIOSK: // 키오스크 알림톡 사용
      alarmTalk = rootStore.settingStore.getAlarmTalkYn === "Y"; // Y: 사용, N: 미사용
      break;
    case MobileOrderFg.QR_ORDER: // QR 알림톡 사용
      alarmTalk = rootStore.settingStore.getQrAlarmtalkYn === "1"; // 0: 미사용, 1: 사용
      break;
    case MobileOrderFg.TABLE_ORDER:
      alarmTalk = false; // 테이블 오더는 알림톡 미사용
      break;
    default:
      alarmTalk = rootStore.settingStore.getAlarmTalkYn === "Y";
      break;
  }

  return alarmTalk ? "AlarmTalk" : "";
}

//주문채널별(키오스크,포스선불,okdc) 연동 설정여부
export function kdsSetYn(rootStore) {
  if (
    rootStore.settingStore.getKioskOrderYn == "Y" ||
    rootStore.settingStore.getPosOrderYn == "Y" ||
    rootStore.settingStore.getDcOrderYn == "Y"
  ) {
    return true;
  }
}

// 에러로직
export function frontLog(rootStore, level, location, msg) {
  let arr = {
    level: level,
    location: location,
    message: msg,
  };
  console.log(JSON.stringify(arr));
}
